import { render, staticRenderFns } from "./UserExamAppHeaderProminent.vue?vue&type=template&id=ec1d3fb0&"
import script from "./UserExamAppHeaderProminent.vue?vue&type=script&lang=ts&"
export * from "./UserExamAppHeaderProminent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports